import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'

import { clientApi } from '@/api/client'
import ErrorBox from '@/components/ErrorBox'
import Topbar from '@/components/Topbar'
import Delta from '@/components/Delta'
import Skeleton from '@/components/Skeleton'
import { fmtProb, timeAgo } from '@/utils/format'

export default function Feed() {
  const { watchlistId } = useParams()
  const [data, setData] = useState<any | null>(null)
  const [error, setError] = useState<any>(null)

  useEffect(() => {
    if (!watchlistId) return
    let cancelled = false
    clientApi.feed(watchlistId).then((x) => {
      if (cancelled) return
      setData(x)
    }).catch(setError)
    return () => { cancelled = true }
  }, [watchlistId])

  if (!data && !error) return (
    <div className="container">
      <Topbar subtitle="Updates feed" />
      <div className="grid" style={{ marginTop: 16 }}>
        <Skeleton variant="card" count={4} />
      </div>
    </div>
  )

  const updates = (data?.updates || []) as any[]

  return (
    <div className="container">
      <Topbar
        subtitle="Updates feed"
        right={
          <Link className="btn" to={`/watchlists/${watchlistId}`}>
            Back
          </Link>
        }
      />

      <div className="grid">
        {updates.map((u: any, idx: number) => {
          const label = u.label || u.scored_question?.title || u.canonical_question?.title || u.item_id
          const prob = u.internal_update_json?.probability
          const edge = u.edge_live
          const borderClass = typeof edge === 'number'
            ? (edge > 0 ? 'feed-card-positive' : 'feed-card-negative')
            : 'feed-card-neutral'
          const sources: string[] = u.prompt_safe_update_json?.sources || []

          return (
            <div key={`${u.run_id}_${idx}`} className={`feed-card ${borderClass}`}>
              <div className="feed-card-header">
                <Link to={`/items/${u.item_id}`} className="titleLink">
                  {label}
                </Link>
                <span className="muted" style={{ fontSize: 12, whiteSpace: 'nowrap' }}>
                  {timeAgo(u.as_of)}
                </span>
              </div>

              {u.canonical_question?.title && (
                <div className="muted" style={{ fontSize: 12 }}>
                  Event: {u.canonical_question.title}
                </div>
              )}

              <div style={{ marginTop: 6 }}>
                <span className="mono">{fmtProb(prob)}</span>
                {typeof u.market_prob_live === 'number' && (
                  <span className="muted" style={{ marginLeft: 8, fontSize: 12 }}>
                    Mkt: {fmtProb(u.market_prob_live)}
                  </span>
                )}
              </div>

              {u.prompt_safe_update_json?.summary && (
                <div style={{ marginTop: 6, fontSize: 13 }}>
                  {String(u.prompt_safe_update_json.summary).slice(0, 200)}
                </div>
              )}

              {sources.length > 0 && (
                <div className="feed-card-sources">
                  {sources.slice(0, 3).map((url: string, si: number) => (
                    <a key={si} className="feed-source-link" href={url} target="_blank" rel="noreferrer">
                      source
                    </a>
                  ))}
                </div>
              )}
            </div>
          )
        })}

        {error ? <ErrorBox error={error} /> : null}
      </div>
    </div>
  )
}
